import { useProposeSlotsMutation } from '../api';

/**
 * Hook para que el seller proponga slots.
 * Uso:
 *   const { proposeSlots, isLoading } = useProposeSlots()
 *   await proposeSlots({ offer_id, slots: ["2026-06-02T10:00:00", ...] })
 */
export function useProposeSlots() {
  const [trigger, { isLoading, isError, isSuccess, error, data }] = useProposeSlotsMutation();

  return {
    proposeSlots: trigger,
    isLoading,
    isError,
    isSuccess,
    error,
    data,
  };
}
